import { XCircleIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNotification } from "../../contextApi/NotificationProvider";
import { motion } from "framer-motion";

import { getUserDetails, signUpUser } from "../../redux/ReduxSlices/authSlice";
import { deactivateManager } from "../../redux/ReduxSlices/managerSlice";
import { FiLoader } from "react-icons/fi";
import AssignRole from "../assessments/AssignRole";
import { FaRegEdit } from "react-icons/fa";
import EditManagerPopup from "../assessments/EditManagerPopup";
import { MdDeleteOutline, MdOutlineDeleteOutline } from "react-icons/md";

const AddAdminStaff = () => {
  const { userData, error } = useSelector((state) => state.auth);
  const [members, setMembers] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [excutiveMember, setExcutiveMember] = useState([]);
  const [managerToDelete, setmanagerToDelete] = useState("");
  const [executiveSearchTerm, setExecutiveSearchTerm] = useState("");
  const [summaryType, setSummaryType] = useState("");
  const [deleteType, setDeleteType] = useState("manager");
  const dispatch = useDispatch();
  const { showNotification } = useNotification();
  const { loading } = useSelector((state) => state.auth);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const { isloading, iserror, success, historyData } = useSelector(
    (state) => state.excutive
  );
  const [editManagerPopup, setEditManagerPopup] = useState(false)

  const toggleSummaryPopup = () => {
    setIsSummaryOpen(!isSummaryOpen);
  };
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [updateData, setUpdateData] = useState({
    firstName: "",
    lastName: "",
    title: "",
    id: ""
  })

  const handleExecutiveSearch = (value) => {
    setExecutiveSearchTerm(value.toLowerCase());
  };

  const onSubmit = async (data) => {
    const payload = {
      user: {
        first_name: data.firstName,
        last_name: data.lastName,
        email: data.email,
        password: data.password,
        user_type: "cfo",
        owner_id: userData?.user_info?.user_pk,
      },
      company_id: userData?.company_info?.company_pk,
    };

    try {
      const result = await dispatch(signUpUser(payload)).unwrap();

      if (result.success === false) {
        showNotification(
          result.message ||
          "Signup failed. Please enter a different email address",
          "error",
          8000
        );
      } else {
        showNotification(
          "We've emailed the Site Admin and are waiting for their response",
          "success",
          8000
        );
        reset();
        dispatch(getUserDetails());
        // setShowOtpPopup(true);
      }
    } catch (err) {
      const errorMsg =
        err?.message || err?.error || "Something went wrong. Please try again";
      showNotification(errorMsg, "error", 5000);
      console.error("Admin error:", err);
    }
  };

  const {
    register: executiveRegister,
    handleSubmit: executiveHandleSubmit,
    reset: executiveReset,
    formState: { errors: executiveErrors },
  } = useForm();

  const onSubmitHrAdmint = async (data) => {
    const payload = {
      user: {
        first_name: data.firstName,
        last_name: data.lastName,
        email: data.email,
        owner_id:
          userData?.user_info?.user_type === "cfo"
            ? userData?.user_info?.owner_id
            : userData?.user_info?.user_pk,
        cfo_id:
          userData?.user_info?.user_type === "owner"
            ? null
            : userData?.user_info?.user_pk,
        user_type: "hr",
      },
      company_id: userData?.company_info?.company_pk,
    };

    const result = await dispatch(signUpUser(payload))
      .unwrap()
      .then((response) => {
        const res = Array.isArray(response) ? response[0] : response;

        if (res.success === true) {
          showNotification(
            "We've emailed the Site Manager and are waiting for their response",
            "success",
            8000
          );
          executiveReset();
          dispatch(getUserDetails());
        } else {
          showNotification(
            res.message || "Add Site Manager failed. Please try again",
            "error",
            8000
          );
          executiveReset();
        }
      })
      .catch((err) => {
        console.error("Add Hr failed:", err);
        showNotification("Add Site Manager failed", "error", 8000);
      });
  };
  useEffect(() => {
    dispatch(getUserDetails());
  }, []);

  useEffect(() => {
    if (userData?.cfo) {
      setMembers(userData.cfo);
    }
  }, [userData]);

  useEffect(() => {
    if (userData?.hr) {
      setExcutiveMember(userData?.hr);
    }
  }, [userData]);

  useEffect(() => {
    if (userData?.managers) {
      setMembers(userData.managers);
    }
  }, [userData]);

  const handleSearch = (value) => {
    setSearchTerm(value.toLowerCase());
  };

  const handleDelete = (id, type) => {
    setmanagerToDelete(id);
    setDeleteType(type);
    setDeletePopup(true);
  };

  const handleUpdateManager = (first_name, last_name, id, title) => {
    setUpdateData({
      firstName: first_name ?? "",
      lastName: last_name ?? "",
      title: title ?? "",
      id: id ?? ""
    })
    setEditManagerPopup(true)
  }

  const deleteManager = async () => {
    try {
      let payload;
      let response;

      if (deleteType === "manager") {
        payload = {
          is_deleted: true,
          id: managerToDelete,
        };
        response = await dispatch(deactivateManager(payload)).unwrap();
      } else if (deleteType === "executive") {
        payload = {
          is_deleted: true,
          id: managerToDelete,
        };
        response = await dispatch(deactivateManager(payload)).unwrap();
      }

      if (response.success) {
        if (deleteType === "manager") {
          await dispatch(getUserDetails());
          showNotification("Site Admin deleted successfully", "success", 8000);
        } else {
          await dispatch(getUserDetails());
          showNotification(
            "Site Manager deleted successfully",
            "success",
            8000
          );
        }
      } else {
        showNotification("Something went wrong", "error", 8000);
      }
      setDeletePopup(false);
    } catch (error) {
      console.log("error", error);
      showNotification("Something went wrong", "error", 8000);
      setDeletePopup(false);
    }
  };

  return (
    <div className="p-2 md:p-2 min-h-screen bg-gradient-to-br from-white to-gray-50">
      <div className="p-2 md:p-6 ">
        {loading && (
          <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
            <FiLoader className="animate-spin text-[#822bda] text-4xl" />
          </div>
        )}
        <div
          className={`grid gap-4 md:gap-6 max-md:gap-8   ${userData?.user_info?.user_type === "cfo"
            ? "grid-cols-1 md:grid-cols-3"
            : "grid-cols-1 lg:grid-cols-3"
            }`}
        >
          {(userData?.user_info?.user_type == "owner") && (
            <motion.div
              className="h-fit  top-6 p-2 md:p-4  border rounded-lg border-voilet-100 to-gray-50 shadow-lg"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <h2 className="text-2xl font-bold text-gray-800 max-md:ml-10 max-md:mt-2 addSiteAdmin">
                Add Site Admin
              </h2>
              <p className="text-gray-600 text-xs mb-4 bg-violet-50 px-2 py-1 rounded-lg mt-4">
                &#9432; The Site Admin has full authority to make payments and
                manage all account activity
              </p>
              <p className="text-sm text-gray-600 mt-1 max-md:mt-2">
                Assign system roles to team members by email.
              </p>
              <div className="   mt-4 max-md:p-4">
                <div className="flex justify-between items-center mb-8">
                  <h3 className="text-sm font-semibold text-gray-700 uppercase ">
                    Assign a new role
                  </h3>
                  <button
                    onClick={() => {
                      setSummaryType("manager");
                      setIsSummaryOpen(true);
                    }}
                    className="text-sm bg-violet-50 text-gtay-800 border   py-0 md:py-1 px-2 rounded-md"
                  >
                    Details
                  </button>
                </div>
                <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email Address
                    </label>
                    <input
                      type="email"
                      placeholder="Enter user email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Invalid email format",
                        },
                      })}
                      className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${errors.email
                        ? "border-red-500 focus:ring-red-400"
                        : "border-gray-300 focus:ring-violet-500"
                        }`}
                    />
                    {errors.email && (
                      <p className="text-xs text-red-500 mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>

                  <div className="flex gap-4">
                    <div className="w-1/2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        First Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter first name"
                        {...register("firstName", {
                          required: "First name is required",
                        })}
                        className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${errors.firstName
                          ? "border-red-500 focus:ring-red-400"
                          : "border-gray-300 focus:ring-violet-500"
                          }`}
                      />
                      {errors.firstName && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.firstName.message}
                        </p>
                      )}
                    </div>

                    <div className="w-1/2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Last Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter last name"
                        {...register("lastName", {
                          required: "Last name is required",
                        })}
                        className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${errors.lastName
                          ? "border-red-500 focus:ring-red-400"
                          : "border-gray-300 focus:ring-violet-500"
                          }`}
                      />
                      {errors.lastName && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.lastName.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full btn-gradient text-white py-2 px-4 rounded-md text-sm font-medium transition duration-300"
                  >
                    {loading ? "Adding..." : "Add Site Admin"}
                  </button>
                </form>
              </div>

              <hr className="mt-4" />
              <div className="mt-4">
                <div className="mt-4 siteAdminList">
                  {members.filter((member) => !member.is_deleted).length >
                    0 && (
                      <div className="max-md:p-4">
                        <h3 className="text-xs font-semibold text-gray-700 mb-4 uppercase flex flex-col sm:flex-row sm:justify-between sm:items-center siteAdminList">
                          <span>Site Admins</span>

                          {/* Search Input */}
                          <div className="mt-4 sm:mt-0 w-full sm:w-[30%]">
                            <input
                              type="text"
                              placeholder="Search User by name or email"
                              className="w-full border border-gray-300 rounded-md px-3 py-0 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 placeholder:text-sm placeholder:font-normal"
                              onChange={(e) => handleSearch(e.target.value)}
                            />
                          </div>
                        </h3>

                        {/* Filtered List */}
                        <div className="space-y-2 overflow-y-auto max-h-[350px] pr-1">
                          {members
                            .filter(
                              (member) =>
                                !member.is_deleted &&
                                (member.first_name
                                  ?.toLowerCase()
                                  .includes(searchTerm?.toLowerCase() || "") ||
                                  member.email
                                    ?.toLowerCase()
                                    .includes(searchTerm?.toLowerCase() || ""))
                            )
                            .map((member) => (
                              <div key={member.id} className="">
                                <div className="bg-violet-50 border border-violet-200 rounded-md px-2 py-1.5 shadow-sm  flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-4">
                                  <div className="w-full sm:w-auto flex flex-col max-w-full">
                                    <p className="text-sm font-medium text-violet-800 truncate">
                                      {member.first_name?.length > 27
                                        ? `${member.first_name.slice(0, 27)}...`
                                        : member.first_name || "—"}
                                    </p>
                                    <p className="text-xs text-gray-600 truncate max-w-[180px] sm:max-w-none">
                                      {member.email?.length > 15
                                        ? `${member.email.slice(0, 15)}...`
                                        : member.email || "—"}
                                    </p>
                                  </div>

                                  <div className="flex gap-4 max-md:flex-col">
                                    <div className="flex justify-center items-center" >
                                      <p
                                        className={`text-xxs px-1 py-0.5 rounded-sm ${member.otp_verify_status
                                          ? "text-green-700 bg-green-100"
                                          : "text-gray-600 bg-gray-200"
                                          }`}
                                      >
                                        {member.otp_verify_status
                                          ? "Approved"
                                          : "Approval Pending"}
                                      </p>
                                    </div>
                                    <div className="hidden sm:block items-center justify-center">
                                      <button
                                        onClick={() =>
                                          // setEditManagerPopup(true)
                                          handleUpdateManager(member.first_name, member.last_name, member.user_pk, "Update reporting manager")
                                        }
                                        className="text-blue-700 rounded px-1.5 mt-2 text-xxs hover:text-blue-500 transition flex items-center ml-1"
                                      >
                                        <span className="hidden sm:block"><FaRegEdit size={15} /></span>
                                      </button>
                                      {/* Delete Button */}
                                      <button
                                        onClick={() =>
                                          handleDelete(member.user_pk, "manager")
                                        }
                                        className="text-red-500  rounded px-1.5 mt-2 text-xxs hover:text-red-700 transition flex items-centerFFFF"
                                      >
                                        <span className="hidden sm:block"><MdOutlineDeleteOutline size={20} /></span>
                                      </button>
                                    </div>
                                  </div>

                                  {/* Mobile version of status + remove button */}
                                  <div className="flex sm:hidden  items-center align-middle  justify-end w-full mt-2">
                                    <div className=" w-full flex flex-row justify-between ">
                                      <button
                                        onClick={() =>
                                          // setEditManagerPopup(true)
                                          handleUpdateManager(member.first_name, member.last_name, member.user_pk, "Update reporting manager")
                                        }
                                        className=" text-blue-500 text-sm hover:text-blue-700 transition flex flex-row items-center gap-2"
                                      >
                                        <span className="">
                                          Edit
                                        </span>
                                        <FaRegEdit size={20} />
                                      </button>
                                      <div className="flex gap-1">
                                        <p
                                          className={`text-xs px-2 py-0.5 rounded-lg ${member.otp_verify_status
                                            ? "text-green-700 bg-green-100"
                                            : "text-gray-600 bg-gray-200"
                                            }`}
                                        >
                                          {member.otp_verify_status
                                            ? "Approved"
                                            : "Approval Pending"}
                                        </p>

                                        <button
                                          onClick={() =>
                                            handleDelete(member.user_pk, "manager")
                                          }
                                          className="text-red-500 text-xs hover:text-red-700 transition flex items-center "
                                        >
                                          Remove <MdOutlineDeleteOutline size={22} />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                          {members.filter((member) => {
                            const name = member.first_name || "";
                            const email = member.email || "";
                            return (
                              !member.is_deleted &&
                              (name
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) ||
                                email
                                  .toLowerCase()
                                  .includes(searchTerm.toLowerCase()))
                            );
                          }).length === 0 &&
                            searchTerm && (
                              <p className="text-sm text-gray-500 italic">
                                No matching managers found.
                              </p>
                            )}
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </motion.div>
          )}

          {/* Right Section - Add Executive */}
          {(userData?.user_info?.user_type == "owner" || userData?.user_info?.user_type == "cfo") && (<motion.div
            className="  h-fit  top-6 p-2 md:p-4  border rounded-lg border-voilet-100 to-gray-50 shadow-lg"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="space-y-4 ">
              <h2 className="text-2xl font-bold text-start text-gray-800  md:text-left max-md:ml-12 addSiteManager">
                Add Site Managers
              </h2>
              <p className="text-gray-600 text-xs mb-4 bg-violet-50 px-2 py-1 rounded-lg">
                &#9432; The Site Manager can manage all account activity except
                make payment
              </p>
              <p className="text-sm text-gray-600  max-md:mt-1">
                Assign system roles to team members by email.
              </p>
              <div className="max-md:p-4 rounded-lg ">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-sm font-semibold text-gray-700 uppercase">
                    Assign a new role
                  </h3>
                  {/* {userData?.user_info?.user_type !== "cfo" && ( */}
                  <button
                    onClick={() => {
                      setSummaryType("executive");
                      setIsSummaryOpen(true);
                    }}
                    className="mt-4 text-sm bg-violet-50 text-gray-800 border py-0 md:py-1 px-2 rounded-md"
                  >
                    Details
                  </button>
                  {/* )} */}
                </div>
                <form
                  className="space-y-4"
                  onSubmit={executiveHandleSubmit(onSubmitHrAdmint)}
                >
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email Address
                    </label>
                    <input
                      type="email"
                      placeholder="Enter user email"
                      {...executiveRegister("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Invalid email format",
                        },
                      })}
                      className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${executiveErrors.email
                        ? "border-red-500 focus:ring-red-400"
                        : "border-gray-300 focus:ring-violet-500"
                        }`}
                    />
                    {executiveErrors.email && (
                      <p className="text-xs text-red-500 mt-1">
                        {executiveErrors.email.message}
                      </p>
                    )}
                  </div>

                  <div className="flex gap-4">
                    <div className="w-1/2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        First Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter first name"
                        {...executiveRegister("firstName", {
                          required: "First name is required",
                        })}
                        className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${executiveErrors.firstName
                          ? "border-red-500 focus:ring-red-400"
                          : "border-gray-300 focus:ring-violet-500"
                          }`}
                      />
                      {executiveErrors.firstName && (
                        <p className="text-xs text-red-500 mt-1">
                          {executiveErrors.firstName.message}
                        </p>
                      )}
                    </div>

                    <div className="w-1/2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Last Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter last name"
                        {...executiveRegister("lastName", {
                          required: "Last name is required",
                        })}
                        className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${executiveErrors.lastName
                          ? "border-red-500 focus:ring-red-400"
                          : "border-gray-300 focus:ring-violet-500"
                          }`}
                      />
                      {executiveErrors.lastName && (
                        <p className="text-xs text-red-500 mt-1">
                          {executiveErrors.lastName.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isloading}
                    className="w-full btn-gradient text-white py-2 px-4 rounded-md text-sm font-medium transition duration-300"
                  >
                    Add Site Manager
                  </button>
                </form>
              </div>
            </div>

            <hr className="mt-4" />
            <div className="mt-4 siteManagerList">
              {excutiveMember.filter((member) => !member.is_deleted).length >
                0 && (
                  <div className="max-md:p-4">
                    <h3 className="text-xs font-semibold text-gray-700 mb-4 uppercase flex flex-col sm:flex-row sm:justify-between sm:items-center siteManagerList">
                      <span>Site Managers</span>

                      {/* Search Input */}
                      <div className="mt-4 sm:mt-0 w-full sm:w-[30%]">
                        <input
                          type="text"
                          placeholder="Search User by name or email"
                          className="w-full border border-gray-300 rounded-md px-3 py-0 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 placeholder:text-sm placeholder:font-normal"
                          onChange={(e) => handleExecutiveSearch(e.target.value)}
                          value={executiveSearchTerm}
                        />
                      </div>
                    </h3>

                    {/* Filtered List */}
                    <div className="space-y-2 overflow-y-auto max-h-[350px] pr-1">
                      {excutiveMember
                        .filter(
                          (member) =>
                            !member.is_deleted &&
                            (member.first_name
                              ?.toLowerCase()
                              .includes(
                                executiveSearchTerm?.toLowerCase() || ""
                              ) ||
                              member.email
                                ?.toLowerCase()
                                .includes(
                                  executiveSearchTerm?.toLowerCase() || ""
                                ))
                        )
                        .map((member) => (
                          <div key={member.id}>
                            <div className="bg-violet-50 border border-violet-200 rounded-md px-2 py-1.5 shadow-sm flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-4">
                              <div className="w-full sm:w-auto flex flex-col max-w-full">
                                <p className="text-sm font-medium text-violet-800 truncate">
                                  {member.first_name?.length > 27
                                    ? `${member.first_name.slice(0, 27)}...`
                                    : member.first_name || "—"}
                                </p>
                                <p className="text-xs text-gray-600 truncate max-w-[180px] sm:max-w-none">
                                  {member.email?.length > 15
                                    ? `${member.email.slice(0, 15)}...`
                                    : member.email || "—"}
                                </p>
                              </div>

                              <div className="flex gap-4 max-md:flex-col">
                                <div className="flex justify-center items-center">
                                  <p
                                    className={`text-xxs px-1 py-0.5 rounded-sm ${member.otp_verify_status
                                      ? "text-green-700 bg-green-100"
                                      : "text-gray-600 bg-gray-200"
                                      }`}
                                  >
                                    {member.otp_verify_status
                                      ? "Approved"
                                      : "Approval Pending"}
                                  </p>
                                </div>
                                <div className="hidden sm:block items-center justify-center">
                                  <button
                                    onClick={() =>
                                      // setEditManagerPopup(true)
                                      handleUpdateManager(member.first_name, member.last_name, member.user_pk, "Update reporting manager")
                                    }
                                    className="text-blue-700 rounded px-1.5 mt-2 text-xxs hover:text-blue-500 transition flex items-center ml-1"
                                  >
                                    <span className="hidden sm:block"><FaRegEdit size={15} /></span>
                                    {/* <FaRegEdit size={15} /> */}
                                  </button>
                                  {/* Status */}

                                  {/* Delete Button */}
                                  <button
                                    onClick={() =>
                                      handleDelete(member.user_pk, "executive")
                                    }
                                    className="text-red-500  rounded px-1.5 mt-2 text-xxs hover:text-red-700 transition flex items-center"
                                  >
                                    <span className="hidden sm:block"><MdOutlineDeleteOutline size={20} /></span>
                                  </button>
                                </div>
                              </div>

                              {/* Mobile version of status + remove button */}
                              <div className="flex sm:hidden items-center align-middle justify-end w-full mt-2">
                                <div className=" w-full flex flex-row justify-between ">
                                  <button
                                    onClick={() =>
                                      // setEditManagerPopup(true)
                                      handleUpdateManager(member.first_name, member.last_name, member.user_pk, "Update reporting manager")
                                    }
                                    className=" text-blue-500 text-sm hover:text-blue-700 transition flex flex-row items-center gap-2"
                                  >
                                    <span className="">
                                      Edit
                                    </span>
                                    <FaRegEdit size={20} />
                                  </button>
                                  <div className="flex gap-1">
                                    <p
                                      className={`text-xs px-2 py-0.5 rounded-lg ${member.otp_verify_status
                                        ? "text-green-700 bg-green-100"
                                        : "text-gray-600 bg-gray-200"
                                        }`}
                                    >
                                      {member.otp_verify_status
                                        ? "Approved"
                                        : "Approval Pending"}
                                    </p>

                                    <button
                                      onClick={() =>
                                        handleDelete(member.user_pk, "executive")
                                      }
                                      className="text-red-500 text-xs hover:text-red-700 transition flex items-center"
                                    >
                                      Remove <MdOutlineDeleteOutline size={22} />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                      {excutiveMember.filter((member) => {
                        const name = member.first_name || "";
                        const email = member.email || "";
                        return (
                          !member.is_deleted &&
                          (name
                            .toLowerCase()
                            .includes(executiveSearchTerm.toLowerCase()) ||
                            email
                              .toLowerCase()
                              .includes(executiveSearchTerm.toLowerCase()))
                        );
                      }).length === 0 &&
                        executiveSearchTerm && (
                          <p className="text-sm text-gray-500 italic">
                            No matching managers found.
                          </p>
                        )}
                    </div>
                  </div>
                )}
            </div>
          </motion.div>)}

          {/* {userData?.user_info?.user_type === "cfo" && (
            <div className="p-2 mt-8 bg-gradient-to-br from-white to-gray-50 w-full">
              <h3 className="text-2xl font-bold text-gray-800  text-center md:text-left">
                Summary
              </h3>
              <div className="bg-white p-6 rounded-lg shadow-lg h-fit mt-10">
                <p className="text-sm text-gray-600 mb-2">
                  Total Members:{" "}
                  <span className="font-bold text-violet-600">
                    {members.filter((member) => !member.is_deleted).length}
                  </span>
                </p>

                <div className="space-y-4 text-sm max-h-[400px] overflow-y-auto pr-2">
                  {excutiveMember
                    .filter((member) => !member.is_deleted)
                    .map((member) => (
                      <div
                        key={member.id}
                        className="flex justify-between items-center text-gray-700 border-b pb-1"
                      >
                        <span>
                          {member.first_name} {member.last_name}
                        </span>
                        <span className="font-semibold text-violet-500 truncate max-w-[50%] text-right">
                          {member.email}
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )} */}

          {/* {userData?.user_info?.user_type !== "cfo" && ( */}
          <motion.div
            className="h-fit top-6 p-2 md:p-4  border rounded-lg border-voilet-100 to-gray-50 shadow-lg "
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className=" ">
              <div className="order-4 md:order-none">
                <AssignRole />
              </div>
            </div>
          </motion.div>
          {/* )} */}
        </div>
      </div>

      {isSummaryOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm ">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full md:w-2/4 relative mx-4 md:mx-0">
            <button
              onClick={() => setIsSummaryOpen(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <XCircleIcon className="h-5 w-5" />
            </button>

            <h3 className="text-md font-semibold text-gray-700 mb-4">
              {summaryType === "manager"
                ? "Reporting Manager Summary"
                : "Executive Summary"}
            </h3>

            <p className="text-sm text-gray-600 mb-2">
              Total Members:{" "}
              <span className="font-bold text-violet-600">
                {summaryType === "manager"
                  ? members.filter((member) => !member.is_deleted).length
                  : excutiveMember.filter((member) => !member.is_deleted)
                    .length}
              </span>
            </p>

            <div className="space-y-2 text-sm">
              {(summaryType === "manager" ? members : excutiveMember)
                .filter((member) => !member.is_deleted)
                .map((member) => (
                  <div
                    key={member.id}
                    className="flex justify-between text-gray-700 border-b pb-1"
                  >
                    <span>
                      {member.first_name} {member.last_name}
                    </span>
                    <span className="font-semibold text-violet-500">
                      {member.email}
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      {deletePopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm p-4">
          <div className="relative bg-white p-8 rounded-md shadow-xl w-[380px] space-y-2 text-center">
            <h2 className="text-lg flex items-center justify-center gap-2">
              {deleteType === "manager"
                ? "Are you sure you want to delete site admin"
                : "Are you sure you want to delete site Manager"}
            </h2>
            <div className="flex justify-evenly">
              <button
                className="bg-[#f5f3ff] text-violet-500 py-2 px-6 rounded-lg mt-4 hover:bg-violet-500 hover:text-white transition-all"
                onClick={() => deleteManager()}
              >
                Yes
              </button>
              <button
                className="bg-[#f5f3ff] text-violet-500 py-2 px-6 rounded-lg mt-4 hover:bg-violet-500 hover:text-white transition-all"
                onClick={() => {
                  setmanagerToDelete("");
                  setDeletePopup(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {
        editManagerPopup && <EditManagerPopup updateData={updateData} setEditManagerPopup={setEditManagerPopup} />
      }
    </div>
  );
};

export default AddAdminStaff;
